export default {
    left: {
        detection: "点击进行设备检测",
        group: "我的分组: ",
        location: "日程地点: ",
        description: "日程说明: ",
        scoreChart: "评分表: ",
        scoreChartDescription: "评分表说明: ",
    },
    logout: "退出登录",
    right: {
        title: "任务列表",
        searchPlaceholder: "名称",
    },
    interviewStatus: {
        login: "已登录",
        online: "在线",
        offline: "离线",
    },
    score: "得分",
    average: "平均",
    class: "等级",
    nodata: "暂无任务",
    401: "登录过期，请重新登录",
    status: {
        waiting: "未开始",
        interviewing: "进行中",
        complete: "已结束",
        default: "出错了",
    },
    signOut: {
        msg: "确定退出面试评分系统？",
        cancel: "取消退出",
    },
};
